import { Language, nl } from "../language"

export const useLanguage: (() => Language) = () => {
    return nl;
}

export const useLabel: ((label: string) => string) = (label: string) => {
    const language = useLanguage();
    return label.split('.').reduce((p: any, c: string)=>((p && p[c]) || null), language)
}